<template>
  <div class="task-page">
    <div>
      <adv-title>Task</adv-title>
      <h1>
        <i>{{ task }}</i>
      </h1>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AdvTitle from "../components/AdvTitle.vue";

export default {
  components: { AdvTitle },
  name: "task-page",
  computed: mapGetters(["task"]),
};
</script>

<style lang="less">
.task-page {
  width: 768px;
  height: 768px;
  padding: 120px;
  background-image: url("~@/assets/images/page-blank.png");
  position: relative;
}
</style>
